import axios from "axios";
import dayjs, { Dayjs } from "dayjs";
import { DateRange } from "@mui/x-date-pickers-pro";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useState } from "react";
import { UrlUpdateType } from "use-query-params";
import useCompanyTypeList from "../../phonebook/hooks/useCompanyTypeList";
import AddedContactsActions from "./AddedContactsActions";
import { companyColumns } from "./companyColumns";
import { CompanyRecord } from "./types";

interface CompanyRecordsTabProps {
  selectedEntityId?: number;
  setSelectedEntityId: (newValue: string | null | undefined, updateType?: UrlUpdateType) => void;
}

const CompanyContactsTab = ({ }: CompanyRecordsTabProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [companyRecords, setCompanyRecords] = useState<CompanyRecord[]>([]);
  const today = dayjs();
  const defaultEndDate = today.endOf("day");
  const defaultStartDate = today.subtract(6, "days").startOf("day");
  const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([defaultStartDate, defaultEndDate]);
  const companyTypeList = useCompanyTypeList();

  const fetchCompanyRecords = async () => {
    setIsLoading(true);
    const [startDate, endDate] = dateRange;
    const fromParam = (startDate?.startOf("day") || defaultStartDate).format("YYYY-MM-DD");
    const toParam = (endDate?.endOf("day") || defaultEndDate).format("YYYY-MM-DD");
    try {
      const { data } = await axios.get(`/api/clientphonebook/companyHistory/getNewlyAddedCompanies?from=${fromParam}&to=${toParam}`);
       setCompanyRecords(data);
    } catch (error) {
      console.error("Error fetching company records", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyRecords();
  }, [dateRange]);

  return (
    <>
      <MaterialReactTable
        enableStickyHeader
        columns={companyColumns(companyTypeList)}
        data={companyRecords}
        muiTableBodyRowProps={({ row }) => ({
          sx: { backgroundColor: row.index % 2 === 0 ? "#f4f4f4" : "white" }
        })}
        state={{ isLoading: isLoading }}
        enableGlobalFilter
        enableFacetedValues
        globalFilterFn="includesString"
        renderTopToolbarCustomActions={({ table }) => {
          return (
            <>
              <AddedContactsActions dateRange={dateRange} setDateRange={setDateRange} table={table} />
            </>
          );
        }}
      />
    </>
  );
};

export default CompanyContactsTab;
